interface OverflowState {
  value: Ref<boolean>
  toggle: (value: boolean) => void
}

export default function useOverflow() {
  const overflow = inject('hasOverflow') as OverflowState

  return overflow
}
